import React, { Component } from 'react';
import country from '../country';
import Menu from './Menu';

class Search extends Component {
	constructor(props) {
		super(props);
		this.state = {
			code: '',
			searchlist: [],
			value: ''
		};
		this.getCountry = this.getCountry.bind(this);
		this.titleCase = this.titleCase.bind(this);
		this.setInput = this.setInput.bind(this);
	}

	getCountry = async (e) => {
		var countryname = e.target.value;
		var flag = 0;
		var searchlist = [];
		countryname = this.titleCase(countryname);
		/* console.log(countryname) */
		await country.forEach((data) => {
			if (data.Name.includes(countryname)) {
				if (data.Name === countryname) {
					flag = 1;
					this.setState({
						code: data.Code,
						searchlist: [],
						value: countryname
					});
				} else {
					//if
					var name = (
						<button
							name='country'
							className='mybtn'
							style={{
								width: '100%',
								fontWeight: '800',
								fontSize: 'large'
							}}
							onClick={() => this.setInput(data.Name, data.Code)}
						>
							{data.Name}
						</button>
					);
					searchlist.push(name);
				} //else
			} //if
		});
		if (flag === 0) {
			this.setState({
				code: '',
				searchlist: searchlist,
				value: countryname
			});
		} //if
		if (this.state.value === '') {
			this.setState({
				searchlist: []
			});
		}
	};

	titleCase(str) {
		var splitStr = str.toLowerCase().split(' ');
		for (var i = 0; i < splitStr.length; i++) {
			// You do not need to check if i is larger than splitStr length, as your for does that for you
			// Assign it back to the array
			splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
		}
		// Directly return the joined string
		return splitStr.join(' ');
	}
	setInput(name, code) {
		console.log('input is set', name);
		this.setState({
			value: name,
			code: code,
			searchlist: []
		});
	}
	render() {
		var menu = '';
		var list = [];
		if (this.state.code) menu = <Menu code={this.state.code} />;
		if (this.state.searchlist.length > 0) {
			list = this.state.searchlist.map((data, index) => {
				return <li>{data}</li>;
			});
		}
		return (
			<div>
				<div className='jumbotron'>
					<div className='container text-center'>
						<h1>Enter your country Name:</h1>
						<br />
						<input
							style={{ width: '80%', height: '35px' }}
							type='text'
							className='capitalize'
							name='country'
							autocomplete='off'
							value={this.state.value}
							ref='country'
							onChange={this.getCountry}
						/>
						<div
							style={{
								listStyle: 'none',
								width: '80%',
								marginLeft: '10%',
								height: 'auto'
							}}
						>
							{list}
						</div>
						<br />
					</div>
				</div>
				{menu}
			</div>
		);
	}
}

export default Search;
